module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Chapter106"
    }
  }, [_c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("“In the Hitler Youth you got meals, you got the uniform, you had nothing to pay but could do what you wanted at that time. You had more or less anything, youth sport and paid from the state. I had seen Hitler only once, as he went from Berlin to Beelitz "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(training airfield south of Werder)")]), _vm._v(" on the train and drove his Mercedes down the road to Sudetenland. As a boy I sat in a tree beside the road, and that was the only way I really could see one of the politicians very close to me. My class were in a gymnasium, thirty-five boys all Hitler Jung. If we had a state day, 12 May or something like that, everybody in the class had to be in uniform. The teacher was a very simple SA man "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(Sturmabteilung [Storm Trooper] ‘Brownshirt’)")]), _vm._v(" but that never made any difference to us.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Generalleutnant Günther Rall transferred from the army to the Luftwaffe in 1939 and flew Me 109s in the Battle of Britain leading 8./Jagdgeschwader 52. He went to the Eastern Front and finished the war as the third highest scoring fighter pilot in history with 275 victories. He had a distinguished career in the post-war Luftwaffe.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("“I was already in the army, an army of soldiers. Then Hitler came. I wanted to go into the air force, because I wanted to fly. And when I was in the air force, then I wanted to be a fighter pilot. I think this is my temperament to be a fighter pilot; it was by choice.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Hauptmann Peter Spoden was a night fighter pilot with Nachtjagdgeschwaders 5 and 6, flying sorties against allied bombers in the Me 110G and Ju 88G, scoring twenty-four victories. He too served in the post-war Luftwaffe and retired in 1981 as a Boeing 747 captain with Lufthansa.")])]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractText1"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("“Only two or three in our class became Hitler Youth leaders, like for example my good friend Hans Adelhütte. He was one of the few who frequently turned up at school in uniform, for which he was made much fun of by some of us who went to the Thielemann Dance School in the town centre of Essen wearing baggy trousers. Hans was a nice, sporty type, not a fanatic, good at school and full of enthusiasm for national socialist ideals. Despite that, he never denounced any of our teachers. He volunteered for the Luftwaffe at the outbreak of war, and became a night fighter before I did, and was shot down over the North Sea after twenty successful combats with RAF bombers. He is buried in my home town, Essen.”")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent"
  }, [_c('span', {
    staticClass: "character-style7"
  }, [_vm._v("Oberleutnant Adelhütte, who possessed the German Cross in Gold, had between fifteen and twenty confirmed victories, but the unit on which he served, and the date of his loss, are not known.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3759e262","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeroesAll_Chapter106.vue
// module id = 93
// module chunks = 0